import {PackItem, packItemMapper, PackItemModel} from './pack-item.model';
import {NamedEntity, NamedEntityModel} from './named-entity.model';

export interface PackVersion extends NamedEntity {
  version: number
  comment: string
  summary?: PackItem[]
}

export class PackVersionModel extends NamedEntityModel<PackVersion> {
  readonly version: number;
  readonly comment: string;
  readonly summary?: PackItemModel[];

  constructor(source: PackVersion) {
    super(source, 'pack');
    this.version = source.version;
    this.comment = source.comment;

    if (source.summary) {
      this.summary = packItemMapper.mapMany(source.summary)
    }
  }
}
